// extracted by mini-css-extract-plugin
export default {"link":"NavLink--link--T1Ljl","linkActive":"NavLink--linkActive--2CwKZ"};